import { useReadContract, useReadContracts } from 'wagmi';

// Hooks
import useContract from '../useContract';

export const useGetAdminsList = isReferralManager => {
  const { contract } = useContract();

  const { data: defaultAdminRole } = useReadContract({
    ...contract,
    functionName: isReferralManager ? 'REFERRAL_MANAGER_ROLE' : 'DEFAULT_ADMIN_ROLE',
  });

  const { data: numberOfAdmins, refetch: refetchNumberOfAdmins } = useReadContract({
    ...contract,
    functionName: 'getRoleMemberCount',
    args: [defaultAdminRole],
  });

  const readContracts = [];

  for (let i = 0; i < (numberOfAdmins || 0); i++) {
    readContracts.push({
      ...contract,
      functionName: 'getRoleMember',
      args: [defaultAdminRole, i],
    });
  }

  const { data: adminsList, refetch: refetchAdminsList } = useReadContracts({
    contracts: readContracts,
  });

  return { adminsList, refetchAdminsList, refetchNumberOfAdmins };
};
